<template>
    <button v-on:click="sendMailtoUser" :disabled="asSend" class="rounded-xl px-8 h-[35px] border font-light bg-black text-white flex items-center gap-x-2">
        <Send v-if="!asSend" :size="16" strokeWidth="1.2"/>
        <Loader2 v-else :size="16" strokeWidth="1.2"/>
        Envoyer par mail
    </button>
</template>
<script>
import API from '@/service/API';
import Swal from 'sweetalert2';
import {Send,Loader2} from "lucide-vue-next"
export default {
    name: "LoadDocument",
    props: ["data","month"],
    components:{
        Send,Loader2
    },
    data(){
        return {
            asSend: false
        }
    },
    methods: {
        sendMailtoUser(){
            this.asSend = true;
            API.post("payroll/sendMail",{"month": this.month,"matricule": this.data.matricule,})
            .then((res)=>{
                if(!res.data.status) throw Error(res.data.message)
                // this.$emit('child-action');
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=> this.asSend = false)
        },
    }
}
</script>